import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';

import { IMPORT_SUMMARY_CONST } from '../../../constants';
import { postImportServiceSummary } from '../../actions/actionType/services/ImportServiceSummaryActionType';
import { fetchImportFailure, fetchImportStarted, fetchImportSuccess } from '../../actions/sagaActions/services/ImportServiceSummarySagaAction';
import { FetchImportFailurePayload, FetchImportRequest } from '../../actions/types/services/ImportAllServiceSummaryTypes';
import { clearImportServiceSummary } from '../../reducer/services/ImportServiceSummaryReducer';

export async function callImportServiceSummaryApi(data: FormData) {
  return apiWrapper.post<string>(
    `${process.env.REACT_APP_API_BASE_URL}/exim/import?recordType=${IMPORT_SUMMARY_CONST.service}`,
    data,
    {},
    'multipart/form-data',
  );
}
export function* postImportServiceSummaryApi({
  fileData,
}: FetchImportRequest) {
  yield put(clearImportServiceSummary());
  yield put(fetchImportStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callImportServiceSummaryApi, fileData);
    if (isError) {
      throw error;
    }
    // put length check here
    if (data) {
      yield put(fetchImportSuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error: any) {
    const obj: FetchImportFailurePayload = {
      errorCode: String(error?.response?.data.error_code),
      errorMessage: String(error?.response?.data?.errorMessage)
    };
    yield put(fetchImportFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* ImportServiceSummarySaga() {
  yield takeLatest(postImportServiceSummary.POST_IMPORT_SERVICE_SUMMARY, postImportServiceSummaryApi);
}

export const ImportServiceSummarySagaHandler = [fork(ImportServiceSummarySaga)];
